module.exports = __webpack_public_path__ + "static/media/BANNER_parayas.e2855411.jpg";